import Vue from 'vue'

/*注册自定义组件*/
const context = require.context('./', false, /\.(vue)$/);
context.keys().forEach((filename) => {
	const item = context(filename).default
	Vue.component(item.name, item)
})

/*注册自定义svg图标*/
import svgicons from './svgIcon/index'
svgicons.forEach((item) => {
	Vue.component(item.name, item)
})
